<template>
  <section class="margin-both-xl container">
    <ul class="featured-boxes">
      <li class="box" v-for="({title, small_title, image, link}, id) in data.featured_boxes" :key="id">
        <WpLink class="inner fost" :url="link.url" :title="link.title" :target="link.target">
          <span class="info">
            <h3 class="titler fost--35 font--700">{{ title }}</h3>
            <h4 v-if="small_title" class="sub-title jost--25 font--500">{{small_title}}</h4>
          </span>
          <WpImage 
            :image="image"
            size="medium_large"
            cover
            background
            caption
          />
        </WpLink>
      </li>
    </ul>
  </section>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import WpLink from '@/components/elements/WpLink'

export default {
  name: 'section-image',
  props: ['data'],
  components:{
      WpImage,
      WpLink
    },
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

  .featured-boxes{
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: -25px;
    list-style: none;
    justify-content: center;
    @include mquery($phone){
      margin: -15px;
    }

    .info{
      padding: 25px;
      display: block;
      @include mquery($phone){
        padding: 20px;
      }

    }
    .box{
      list-style: none;
      max-width: 33.33%;
      width: 100%;
      padding: 25px;
      text-align: center;
      @include mquery($tablet){
        max-width: 50%;
      }
      @include mquery($phone){
        max-width: 100%;
        padding: 15px;
      }

    }
    .inner{
      display: block;
      text-decoration: none;
      background-color: $green;
      transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
      &:hover{
        background-color: $dark;
        color: #fff;
      }
    }
    .titler{
      margin-top: 0;
      margin-bottom: 0;
    }
    .sub-title{
      margin-top: 5px;
    }
  }
</style>